var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94503 8.25557C6.94503 6.83087 8.09998 5.67592 9.52468 5.67592C10.9494 5.67592 12.1043 6.83087 12.1043 8.25557C12.1043 9.68028 10.9494 10.8352 9.52468 10.8352C8.09998 10.8352 6.94503 9.68028 6.94503 8.25557Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99502 7.36451C3.26778 4.05546 6.033 1.50879 9.35328 1.50879H9.69613C13.0164 1.50879 15.7816 4.05546 16.0544 7.36451C16.2012 9.14614 15.6509 10.9152 14.5193 12.2991L10.7149 16.9519C10.0997 17.7042 8.94967 17.7042 8.33454 16.9519L4.5301 12.2991C3.39849 10.9152 2.84816 9.14614 2.99502 7.36451ZM9.52468 4.48531C7.44242 4.48531 5.75442 6.17332 5.75442 8.25557C5.75442 10.3378 7.44242 12.0258 9.52468 12.0258C11.6069 12.0258 13.2949 10.3378 13.2949 8.25557C13.2949 6.17332 11.6069 4.48531 9.52468 4.48531Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.158b7015b23e06b809644c16e9109bae.svg";
export { ForwardRef as ReactComponent };